import { render, staticRenderFns } from "./PaymentMethodPanel.vue?vue&type=template&id=3a1a35a6&scoped=true&"
import script from "./PaymentMethodPanel.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1a35a6",
  null
  
)

export default component.exports